<template>
  <div>
    <px-view-header title="Ofertas" :breadcrumbs="breadcrumbs"/>
    <px-ofertas-header :on-click-refresh="onClickRefresh"
                       :on-change-filter="onChangeFilter"/>
    <px-oferta-list :ofertas="ofertas"
                    :loading="loading"
                    :on-change-options="onChangeOptions"
                    :options-list="optionsList"
                    @change="onClickRefresh"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import OfertaList from './OfertaList.vue';
import OfertasHeader from './OfertasHeader.vue';
import OfertaService from './oferta-service';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      empresa: null,
      breadcrumbs: [
        { text: 'Catálogo' },
        { text: 'Ofertas' },
      ],
      ofertas: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'titulo',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemOfertas', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getOfertas();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getOfertas();
    },
    onClickRefresh() {
      this.getOfertas();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getOfertas() {
      this.loading = true;
      const {
        limit,
        offset,
      } = this.listOptions;
      return OfertaService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.ofertas = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: {
    pxOfertaList: OfertaList,
    pxOfertasHeader: OfertasHeader,
  },
};
</script>
